<template>
    <div class="popup" v-if="isOpen">
        <div class="popup-content">
            <img
                src="/img/close-btn.svg"
                class="close-popup-btn"
                @click="closeConfirmPopup"
            />
            <div class="popup-text">
                <div class="popup-title">
                    <i18n-t keypath="dashboard.confirmDate.title" />
                </div>
                <div class="popup-description">
                    <i18n-t
                        keypath="dashboard.confirmDate.description"
                        :date="localFormatDate"
                        :count="vehiclesId?.length ?? '#'"
                    />
                </div>
            </div>
            <div class="person-info-container">
                <div class="person-image">
                    <img src="/img/car-detail/man.png" alt="Person Image" />
                </div>
                <div class="person-details">
                    <div class="detail-name">
                        {{ `${order?.account_manager?.firstname} ${order?.account_manager?.lastname}` }}
                    </div>
                    <div class="detail1">
                        <i18n-t keypath="dashboard.confirmDate.accountManager.email" />
                        : {{ order?.account_manager?.email ?? "-" }}
                    </div>
                    <div class="detail">
                        <i18n-t keypath="dashboard.confirmDate.accountManager.phone" />
                        : {{ order?.account_manager?.phone ?? "-" }}
                    </div>
                    <div class="detail">
                        <i18n-t keypath="dashboard.confirmDate.accountManager.parkingHours" />
                    </div>
                </div>
            </div>
            <div class="button-container">
                <div>
                    <button class="button-text cancel-button" @click="closeConfirmPopup">
                        <i18n-t keypath="dashboard.confirmDate.cancelButton" />
                    </button>
                </div>
                <div>
                    <button class="button-text decline-button" @click="confirmHandle">
                        <i18n-t keypath="dashboard.confirmDate.confirmButton" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    height: 410px;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.popup-text {
    text-align: center;
}

.popup-title {
    width: 313px;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
}

.popup-description {
    width: 314px;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(98, 118, 144, 1);
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
}

.person-info-container {
    display: flex;
    gap: 16px;
    width: 376px;
    height: 108px;
    top: 183px;
    left: 32px;
    padding: 14px;
    text-align: center;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: 10px;
}

.person-image img {
    width: 73px;
    height: 74px;
    border-radius: 4px;
}

.person-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.detail-name {
    height: 17px;
    font-size: 15px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(40, 55, 71, 1);
    white-space: nowrap;
}

.detail1 {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
}

.detail {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
    margin-top: -10px;
}

.button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding-top: 10px;
    width: 110%;
    margin-left: -20px;
}

.button-container button {
    width: 116px;
    height: 40px;
    padding: 10px;
}

.button-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    width: 116px;
    height: 40px;
}

.cancel-button {
    margin-left: 32px;
    color: rgba(26, 160, 225, 1);
    background: white;
    border-radius: 4px;
    border: 1px solid rgba(26, 160, 225, 1);
}

.decline-button {
    margin-right: 32px;
    color: white;
    background: rgba(26, 160, 225, 1);
    border: none;
    border-radius: 4px;
}

.cancel-button:hover,
.decline-button:hover {
    transform: scale(1.05);
}
</style>

<script lang="ts">
import { ConfirmDatePopup } from "@/dashboard/my-orders/new-popup/confirm-date-popup/confirm-date-popup";

export default ConfirmDatePopup;
</script>
